import { useState } from "react";
import { useNavigate } from "react-router-dom";

const ACTIONS = [
  { label: "Registrar Venta Rápida", icon: "ri-shopping-bag-3-line", path: "/admin/ventas" },
  { label: "Entrada de Inventario", icon: "ri-archive-drawer-line", path: "/admin/inventario" },
  { label: "Nuevo Distribuidor / Punto", icon: "ri-user-add-line", path: "/admin/asesores" },
];

const FloatingActions = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col items-end gap-3">
      {open &&
        ACTIONS.map((a, i) => (
          <button
            key={a.path}
            onClick={() => {
              setOpen(false);
              navigate(a.path);
            }}
            style={{ animationDelay: `${i * 50}ms` }}
            className="flex items-center gap-2 pl-3 pr-4 py-2.5 rounded-full glass-panel-strong text-sm font-semibold text-foreground-900 hover:border-accent-500/50 cursor-pointer animate-fade-up whitespace-nowrap"
          >
            <span className="w-6 h-6 flex items-center justify-center text-accent-300">
              <i className={a.icon} />
            </span>
            {a.label}
          </button>
        ))}
      <button
        onClick={() => setOpen((v) => !v)}
        className={`w-14 h-14 rounded-full bg-gradient-to-br from-accent-500 to-primary-600 text-foreground-950 flex items-center justify-center shadow-lg cursor-pointer transition-transform ${
          open ? "rotate-45" : ""
        }`}
        aria-label="Acciones rápidas"
      >
        <i className="ri-add-line text-2xl" />
      </button>
    </div>
  );
};

export default FloatingActions;